module.exports = __webpack_public_path__ + "static/hero_poster-eb3be7c44449eb76965587dd0bc667b4.jpg";